import { NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ParametroService } from 'src/app/core/services/parametro.service';

interface PopupParametro {
  nombre: string;
  valor: string;
}

interface PopupData {
  pre_tittle: string;
  title_text: string;
  body_text: string;
  image_url: string;
  ruta: string;
  visible: boolean;
}

@Component({
  selector: 'app-pop-up',
  standalone: true,
  imports: [DialogModule, NgClass],
  templateUrl: './pop-up.component.html',
  styleUrl: './pop-up.component.scss',
})
export class PopUpComponent implements OnInit {
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);
  private readonly router: Router = inject(Router);
  private readonly parametroService: ParametroService = inject(ParametroService);

  visible = false;
  image_url = '/assets/images/img-toll.jpg';
  title_text!: SafeHtml;
  body_text!: SafeHtml;
  pre_tittle!: SafeHtml;
  ruta = '/auth-empresarial/sign-in';

  private readonly defaultPopupData: PopupData = {
    pre_tittle: 'Bienvenido a Tolis!',
    title_text: 'Nos encontramos en <br /> pre-registro.',
    body_text: 'Si esta interesado en nuestros servicios, <a class="text-primary-500 font-bold" href="/auth-empresarial/sign-up">registrate</a>, nos comunicaremos pronto contigo.',
    image_url: '/assets/images/img-toll.jpg',
    ruta: '/auth-empresarial/sign-in',
    visible: false
  };

  ngOnInit(): void {
    this.initializePopup();
  }

  private initializePopup(): void {
    this.parametroService.getPopUpData().subscribe({
      next: (response: any) => {
        if (response?.data?.length > 0) {
          this.setPopUp(response.data);
        }
      },
      error: (error) => {
        console.error('Error al cargar datos del popup:', error);
      }
    });
  }

  private getParametroValue(parametros: PopupParametro[], nombre: string): string {
    return parametros.find(param => param.nombre.includes(nombre))?.valor || '';
  }

  private async setVariables(parametros: PopupParametro[]): Promise<PopupData> {
    if (!parametros.length) {
      return this.defaultPopupData;
    }

    return {
      pre_tittle: this.getParametroValue(parametros, 'pre_tittle') || this.defaultPopupData.pre_tittle,
      title_text: this.getParametroValue(parametros, 'title_text') || this.defaultPopupData.title_text,
      body_text: this.getParametroValue(parametros, 'body_text') || this.defaultPopupData.body_text,
      image_url: this.getParametroValue(parametros, 'image') || this.defaultPopupData.image_url,
      ruta: this.getParametroValue(parametros, 'ruta') || this.defaultPopupData.ruta,
      visible: this.getParametroValue(parametros, 'popup_show') === '1' || this.defaultPopupData.visible
    };
  }

  private async setPopUp(parametros: PopupParametro[]): Promise<void> {
    if (this.router.url.includes(this.ruta)) {
      const popupData = await this.setVariables(parametros);

      this.visible = popupData.visible;
      this.pre_tittle = this.sanitizer.bypassSecurityTrustHtml(popupData.pre_tittle);
      this.title_text = this.sanitizer.bypassSecurityTrustHtml(popupData.title_text);
      this.body_text = this.sanitizer.bypassSecurityTrustHtml(popupData.body_text);
      this.image_url = popupData.image_url;
      this.ruta = popupData.ruta;
    }
  }

  close(): void {
    this.visible = false;
  }
}
